import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall } from 'lucide-react';
import { CALL_SERVICES } from '../../lib/callServices';
import { CallServiceCard } from '../callServices/CallServiceCard';

/**
 * 랜딩(HomePage)용 블랭킷 전화 상담 소개 (2026-10-22 대표 지시 — 전화로 받는 서비스들을 소셜데이터랩 안에).
 * 대표 18:3x "서비스당 기준 정식 서비스들처럼 하나의 카드로 … 매력적으로 최고의 것들만" → 한 칸에 묶지 않고 서비스마다 카드 하나(CallServiceCard).
 * 팔로워 레이더와 같은 '다른 서비스로의 이동' 형제 섹션. 카드마다 그 서비스 사이트로 이동(출처 꼬리표 socialdataai_home).
 */
const CallServicesCTA: React.FC = () => {
    return (
        <section className="relative overflow-hidden py-12 sm:py-16">
            {/* 배경 글로우 */}
            <div className="pointer-events-none absolute left-1/2 top-24 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-[#E58A74]/10 blur-[120px]" />

            <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: 'easeOut' }}
                    className="mb-7 flex flex-col items-center gap-4 text-center sm:mb-9 lg:items-start lg:text-left"
                >
                    <span className="inline-flex items-center gap-2 rounded-full border border-[#E58A74]/25 bg-[#1a110e]/80 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-[#f2b8a8] backdrop-blur-sm sm:px-5 sm:py-2 sm:text-xs">
                        <PhoneCall className="h-3 w-3 text-[#E58A74] sm:h-4 sm:w-4" />
                        전화 상담 · BLANKET
                    </span>
                    <h2 className="text-[22px] font-bold leading-snug tracking-[-0.01em] break-keep text-white sm:text-[26px] md:text-[30px] lg:text-[32px]">
                        전화 한 통이면,{' '}
                        <span className="bg-gradient-to-r from-[#E58A74] to-[#F2C29B] bg-clip-text text-transparent">바로 시작해요</span>
                    </h2>
                    <p className="max-w-xl text-sm leading-relaxed text-[#A8A8A8] break-keep sm:text-base">
                        가입·카드 없이 <span className="font-semibold text-white">처음 3분은 무료</span>예요. 무료는 휴대폰 번호마다 한 번이에요.
                    </p>
                </motion.div>

                <div className="grid gap-5 sm:gap-6 lg:grid-cols-2">
                    {CALL_SERVICES.map((s, i) => (
                        <CallServiceCard key={s.key} service={s} placement="home" index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CallServicesCTA;
